//#region Libraries
import {
    useState
} from "react";
//#endregion
import SearchDialogAlert from "components/SearchInDialogAlert/components/SearchDialogAlert/SearchDialogAlert";

const DialogSearchCampus = ({
    show, toggleShow,
    campusList, roleName,
    changeCampus
}) => {
    //#region States
    const [matchedCampusList, setMatchedCampusList] = useState([]);
    const [mostSimilarCampus, setMostSimilarCampus] = useState("");
    //#endregion
    //#region Functions
    const fillMatchedCampusList = campusName => {
        const newMatchedData = !campusName
            ? [] 
            : campusList.filter(({ name }) => name.toUpperCase().includes(campusName.toUpperCase()));
        setMatchedCampusList(newMatchedData);
        if (campusName && newMatchedData.length === 0) {
            setMostSimilarCampus(campusList.find(
                ({ name }) => (
                    name[0].toUpperCase() === campusName[0].toUpperCase()
                )
            )?.name || "");
        }
    }
    const clearMatchedCampusList = () => setMatchedCampusList([]);
    //#endregion
    return (
        <SearchDialogAlert 
            title={`Para asignar el rol de ${roleName}, debes elegir un campus`}
            placeholder="Escribe el nombre del campus"
            show={show}
            toggleShow={toggleShow}
            changeSearchField={changeCampus}
            data={matchedCampusList}
            getDataItemText={({ name }) => name}
            fillData={fillMatchedCampusList}
            clearData={clearMatchedCampusList}
            mostSimilar={mostSimilarCampus}
            notFoundMessage="El campus que estás buscando no se encuentra en la lista"
            loadingSearch={false}
            styles={{
                width: "500px",
                padding: "0 60px"
            }}/>
    );
}

export default DialogSearchCampus;